module.exports = __webpack_public_path__ + "static/CalibreBold-3e9198ca90851694815fc7672ab24212.woff";